<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_orderBatchNo_search') ||
                  '交货批次号/客户名称/客户订单号/零售商PO/进口商PO 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <el-badge :value="checkedCount">
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="$emit('mergeShipment')"
              >
                {{ $l('btn_mergeShipment') || '合并发运' }}
              </b-button>
            </el-badge>
            <b-button
              size="sm"
              class="ml-3"
              variant="outline-success"
              @click="$emit('fallback')"
            >
              {{ $l('INDEX.btn_fallback') || '回退' }}
            </b-button>
            <el-dropdown
              trigger="click"
              @command="(e) => $emit('exportFile', e)"
            >
              <b-button size="sm" variant="outline-success" class="ml-3">
                <i class="el-icon-folder-opened"></i>
                {{ $l('INDEX.btn_export') || '导出' }}
              </b-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="task in exportTasks"
                  :key="task.templateGroup"
                  :command="{ ...task }"
                >
                  {{ task.exportName }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </b-input-group>
        </b-form>
      </b-col>

      <b-col cols="5">
        <el-row :gutter="20">
          <el-col :span="16">
            <el-select
              v-model="sortList"
              multiple
              collapse-tags
              size="small"
              style="width:100%"
              form_placeholder_please_select_the_sorting_field
              :placeholder="
                $l('form_placeholder_please_select_the_sorting_field') ||
                  '请选择排序字段'
              "
              clearable
              filterable
              @change="clearSort"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span style="float: left">{{ item.label }}</span>
                <span v-if="item.sortNo" class="radius" style=" ">
                  {{ item.sortNo }}
                </span>
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-dropdown
              :disabled="sortDisabled"
              trigger="click"
              @command="sort"
            >
              <b-button size="sm" variant="outline-primary">
                <i class="el-icon-sort"></i>
                {{ $l('INDEX.products_table_head_sort') || '排序' }}
              </b-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="' ASC'">
                  {{ $l('INDEX.btn_asc') || '升序' }}
                </el-dropdown-item>
                <el-dropdown-item :command="' DESC'">
                  {{ $l('INDEX.btn_desc') || '降序' }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" size="mini" label-width="140px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_customer_name') || '客户名称'"
            >
              <dict-select
                clearable
                v-model="form.custCode"
                filterable
                size="mini"
                url="/master/common/dict/customerSelect"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_endcustomer_name') || '终端客户'"
            >
              <dict-select
                clearable
                v-model="form.endCustCode"
                filterable
                size="mini"
                url="/master/common/dict/customerSelect"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_customerOrderNo') || '客户订单号'"
            >
              <el-input v-model.trim="form.contractNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_batch_label_orderBatchNo') || '批次号'
              "
            >
              <el-input v-model.trim="form.orderBatchNo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_retailerPo') || '零售商PO'"
            >
              <el-input v-model.trim="form.retailerPo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_importerPo') || '进口商PO'"
            >
              <el-input v-model.trim="form.importerPo" clearable size="mini">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_packing_dispatchPort') || '发运港口'"
            >
              <dict-select
                v-model="form.dispatchPort"
                url="/master/port/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_packing_destinationPort') || '目的港口'"
            >
              <dict-select
                v-model="form.destinationPort"
                url="/master/port/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_shipmentStartDate') ||
                    '客户最早交期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginShipmentDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endShipmentDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_shipmentEndDate') ||
                    '客户最晚交期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginShipmentEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endShipmentEndDate"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.beginDeliveryDate"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.endDeliveryDate"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_package_packingType') || '装箱方式'"
            >
              <dict-select
                v-model="form.packingType"
                url="/master/common/dict/biz"
                :body="{ dictType: 'packingType' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
import exportTasks from './export-tasks'
export default {
  props: {
    disabled: { type: Boolean, default: false },
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      exportTasks: exportTasks(this),
      sortList: [],
      options: [
        {
          value: 'contractNo',
          label: this.$l('INDEX.form_customerOrderNo') || '客户订单号',
          sortNo: null,
        },
        {
          value: 'retailerPo',
          label: this.$l('INDEX.order_form_label_retailerPo') || '零售商PO',
          sortNo: null,
        },
        {
          value: 'shipmentDate',
          label:
            this.$l('INDEX.order_form_batch_label_shipmentStartDate') ||
            '客户最早交期',
          sortNo: null,
        },
        {
          value: 'shipmentEndDate',
          label:
            this.$l('INDEX.order_form_batch_label_shipmentEndDate') ||
            '客户最晚交期',
          sortNo: null,
        },
        {
          value: 'deliveryDate',
          label: this.$l('INDEX.form_label_cargoReadyDay') || '货好时间',
          sortNo: null,
        },
      ],
    }
  },
  created() {
    this.query()
  },
  computed: {
    sortDisabled() {
      return this.sortList && this.sortList.length > 0 ? false : true
    },
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    sort(type) {
      let sortData = this.sortList
        .filter(Boolean)
        .map((t) => (t += type))
        .join(',')
      this.form.sortData = sortData
      this.$emit('query', this.form)
    },
    clearSort() {
      this.form.sortData = ''
      this.options.forEach((p) => {
        p.sortNo = ''
      })
      let num = 1
      if (!this.sortDisabled) {
        for (const sort of this.sortList) {
          this.options.find((item) => {
            return item.value == sort
          }).sortNo = num++
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
.radius {
  float: right;
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  background: #238ff9;
  color: #ffffff;
}
</style>
